import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Router } from "@angular/router";
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as Constants from '@emi/shared/constants';
import { Store } from '@ngrx/store';
import { LocalStorageValues } from '@emi/shared/constants';
import { AuthState } from 'libs/shared/state/auth/src/lib/auth.reducer';
import { logout } from 'libs/shared/state/auth/src/lib/auth.actions';

@Injectable({
    providedIn: 'root',
})

export class HttpErrorService implements HttpInterceptor
{
    constructor(private router: Router, private store: Store<AuthState>) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {

                if (error.status === 401) {
                    localStorage.removeItem(LocalStorageValues.LOCAL_STORAGE_SID_KEY);
                    this.store.dispatch(logout())
                }

                if (error.status === 500 || error.status === 501 || error.status === 502 || error.status === 504) {
                    this.router.navigate([Constants.Routes.SYSTEM_ERROR])
                    return EMPTY;
                }
                else {
                    return next.handle(request)
                }
            }));
    }
}
